import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins/filters.js';
// import { i18n } from 'vue-lang-router'

import i18n from './plugins/i18n'

import axios from 'axios'
import VueTheMask from 'vue-the-mask'
// import VueMask from 'v-mask'
import moment from 'moment-timezone'
import VuetifyUpload from "@kingscode/vuetify-upload"
import VTiptap from "@peepi/vuetify-tiptap";
import DatetimePicker from 'vuetify-datetime-picker'
import VueGoogleCharts from "vue-google-charts";
import money from "@titou10/v-money";


import { BASE_URL } from './http'
import { getAuth, getAuthToken, clearAuth } from './services/authService'



Vue.use(VueTheMask)
// Vue.use(VueMask)
Vue.use(VTiptap)
Vue.prototype.$moment = moment;
Vue.config.productionTip = false
Vue.use(VueGoogleCharts);
Vue.use(VuetifyUpload);
Vue.use(DatetimePicker)
Vue.use(money, { precision: 4 });



const sandbox = window.location.href.includes('localhost') ? true : false
Vue.prototype.$sandbox = sandbox
Vue.prototype.$apiURL = sandbox ? `${BASE_URL}/` : 'https://app.canaldoanuncio.com/api/v1/'

const _bootAuth = getAuth();
if (_bootAuth?.user && typeof _bootAuth.user.timezone === 'string')
  moment.tz.setDefault(_bootAuth.user.timezone);

if (_bootAuth?.whitelabel?.country) {
  if (_bootAuth.whitelabel.country == 'Peru') {
    for (let k in i18n.numberFormats) {
      i18n.setNumberFormat(k, {
        currency: {
          style: 'currency',
          currency: 'PEN',
          symbol: 'S./',
          currencyDisplay: 'symbol', // or code
        }
      });
    }
  } else {
    for (let k in i18n.numberFormats) {
      i18n.setNumberFormat(k, {
        currency: {
          style: 'currency',
          currency: 'BRL',
          currencyDisplay: 'symbol'
        }
      });
    }
  }
}


const http = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
})

http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
http.defaults.headers.common['Accept'] = 'application/json'
http.defaults.headers.common['Origin-Request'] = window.location.origin
http.defaults.headers.post['Content-Type'] = 'application/json'
http.defaults.headers.put['Content-Type'] = 'application/json'
http.defaults.headers.get['Content-Type'] = 'application/json;charset=UTF-8'

http.interceptors.request.use(
  (config) => {
    const tokens = getAuthToken()
    if (tokens) {
      config.headers['secureKey'] = tokens.secureKey
      config.headers['accessKey'] = tokens.accessKey
    }
    return config
  },
  (error) => Promise.reject(error)
)

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const suppress = error.config && error.config._suppressGlobalLogout

    if (!error.response) return Promise.reject(error)

    if (!suppress && error.response.status === 401 && !error.config.url.includes('publisherportal/assoc')) {
      if (!error.config._retried) {
        error.config._retried = true
        // Re-hidrata auth antes de retentar (lida com rotação de chave, etc.)
        const refreshed = getAuth()
        if (refreshed) return http(error.config)
      }

      clearAuth()
      window.location.href = '/sair?r=not-authorized'
      return Promise.reject(error)
    }

    return Promise.reject(error)
  }
)

Vue.prototype.$locale = moment.locale()


// #remover(mudar para vuex)
export const EventBus = new Vue();
export const loadedGoogleMapsAPI = new Promise((resolve, reject) => {

  window['GoogleMapsInit'] = resolve;

  let GMap = document.createElement('script');

  GMap.setAttribute('src',
    `https://maps.googleapis.com/maps/api/js?key=AIzaSyBDZQUtQQjIrF2Vus_zv5XRnFBB1-fun50&libraries=places,geometry,visualization&callback=GoogleMapsInit&region=pt-BR`);

  document.body.appendChild(GMap);
});
Vue.prototype.$axios = http;
new Vue({
  router,
  i18n,
  store,
  vuetify,
  data() {
    return {
      loading: false,
      year: this.$moment().format("YYYY"),
      get auth() {
        return getAuth()
      },
      get authToken() {
        return getAuthToken()
      }
    }
  },
  beforeDestroy() {
    if (typeof window === "undefined") return;
    window.removeEventListener("resize", this.onResize, { passive: true });
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  watch: {
    loading: {
      handler(value) {
        setTimeout(() => {
          this.loading = false
        }, 500);
      }
    },
  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 600;
    },
  },
  render: h => h(App)
}).$mount('#app')
